<template>
  <div class="flex justify-center items-start gap-2 my-3">
    <CounterPart
      :label="$t('channel.monthlyPrize.timeRemaining.units.days')"
      :counter="data.days"
      :expired="data.days === 0"
      :priority="priority"
    />

    <span
      class="text-center text-3xl font-sans font-normal uppercase text-white/60"
    >
      :
    </span>

    <CounterPart
      :counter="data.hours"
      :label="$t('channel.monthlyPrize.timeRemaining.units.hours')"
      :expired="data.days === 0 && data.hours === 0"
      :priority="priority"
    />
    <span
      class="text-center text-3xl font-sans font-normal uppercase text-white/60"
    >
      :
    </span>
    <CounterPart
      :label="$t('channel.monthlyPrize.timeRemaining.units.minutes')"
      :counter="data.minutes"
      :expired="data.days === 0 && data.hours === 0 && data.minutes === 0"
      :priority="priority"
    />
    <span
      class="text-center text-3xl font-sans font-normal uppercase text-white/60"
    >
      :
    </span>
    <CounterPart
      :label="$t('channel.monthlyPrize.timeRemaining.units.seconds')"
      :counter="data.seconds"
      :expired="
        data.days === 0 &&
        data.hours === 0 &&
        data.minutes === 0 &&
        data.seconds === 0
      "
      :priority="priority"
    />
  </div>
</template>

<script setup lang="ts">
import CounterPart from "./countdown-unit.vue";
import type { CardPriority } from "./creation/contests";

const _props = defineProps<{
  data: {
    days: number;
    hours: number;
    minutes: number;
    seconds: number;
  };
  priority: CardPriority;
}>();
</script>
